import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton, CircularProgress, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getAgentDetailsByAgentId, getAllAgents, getAllAgentGroups } from '../../api/userApi';
import AddEditUserModal from './addEditUserModal';
import TierCard from '../agent/tierCard';

const PP = "'Poppins', sans-serif";

export default function EditUserPage() {
    const { userId } = useParams();
    const navigate = useNavigate();
    const isCreate = !userId || userId === 'new';
    const [user, setUser] = useState(null);
    const [allUsers, setAllUsers] = useState([]);
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            const [agentsRes, groupsRes] = await Promise.all([
                getAllAgents(),
                getAllAgentGroups()
            ]);
            const agents = agentsRes.data || [];
            setAllUsers(agents);
            setGroups(groupsRes.data || []);
            if (!isCreate) {
                const found = agents.find(a => String(a.userId) === String(userId));
                setUser(found || null);
            }
        } catch (err) {
            console.error('Error loading user:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [userId]);

    if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}><CircularProgress /></Box>;
    if (!isCreate && !user) return <Box sx={{ p: 4, textAlign: 'center' }}><Typography>User not found.</Typography></Box>;

    const displayName = isCreate
        ? 'Add New User'
        : (`${user.lastName ?? ''} ${user.firstName ?? ''}`.trim() || user.alias || user.username);

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <IconButton onClick={() => navigate('/admin/users')} size="small" sx={{ color: '#64748B' }}>
                    <ArrowBackIcon />
                </IconButton>
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: 700, fontFamily: PP, color: '#0F172A' }}>
                        {displayName}
                    </Typography>
                    {!isCreate && (
                        <Typography sx={{ fontSize: '0.82rem', color: '#64748B', fontFamily: PP }}>
                            @{user.username} &middot; {user.userRoles?.map(r => r.roleName).join(', ')}
                        </Typography>
                    )}
                </Box>
            </Box>

            {!isCreate && (
                <Box sx={{ mb: 3 }}>
                    <TierCard userId={user.userId} />
                </Box>
            )}

            <AddEditUserModal
                open={true}
                onClose={() => navigate('/admin/users')}
                user={isCreate ? null : user}
                allUsers={allUsers}
                groups={groups}
                onSaved={isCreate ? () => navigate('/admin/users') : () => {}}
                fullPage={true}
            />
        </Box>
    );
}
